import * as React from 'react';

export interface PromoCodeFormState {
	promoCode: string;
}

export enum PromoCodeStatus {
	Empty,
	Applied,
	NotApplied,
	Provided
}

export enum PromoCodeFieldType {
	Text = 'text',
	Checkbox = 'checkbox'
}

export interface PromoCodeProps {
	status: PromoCodeStatus;
	onAddPromoCode: React.Dispatch<PromoCodeFormState>;
	promoCode?: string;
	isFormOpen: boolean;
	isLoading: boolean;
	onOpenForm: React.DispatchWithoutAction;
	onCloseForm: React.DispatchWithoutAction;
	className?: string;
	promoCodeClassName?: string;
	onClear?: React.DispatchWithoutAction;
	renderAfter?: (props: Omit<PromoCodeProps, 'renderAfter' | 'className'>) => React.ReactElement;
}

export interface PromoCodeFormProps {
	isLoading: boolean;
	onSubmit: React.Dispatch<PromoCodeFormState>;
	status: PromoCodeStatus;
	submitButtonText?: string;
	title?: string;
	inputClassName?: string;
}
